// Set to true to restore the login requirement. Session tokens are sent when available.
export const AUTH_ENABLED = false;
